<template>
  <div class="ApprovalCourse">
    <AppHeader content="审批管理 | 课程审批"></AppHeader>
    <AppBox class="appBox">
      <IPhoneModelContainer ref="iPhoneModelContainer"></IPhoneModelContainer>
      <div style="text-align: center; margin-top: 15px">
        <el-button
            style="width: 150px; margin-right: 200px"
            plain
            type="primary"
            @click="handleDisagree"
        >驳回
        </el-button>
        <el-button style="width: 150px" type="primary" @click="handleAgree"
        >通过
        </el-button>
      </div>
    </AppBox>
    <ApprovalModal :states="states"></ApprovalModal>
  </div>
</template>

<script>
import AppHeader from "@/components/ui/AppHeader/index.vue";
import AppBox from "@/components/ui/AppBox/index.vue";
import IPhoneModelContainer from "@/components/ui/IPhoneModelContainer/index.vue";
import ApprovalModal from "@/pages/ApprovalManagement/ApprovalModal.vue";
import {mapMutations} from "vuex";

export default {
  name: "ApprovalCourse",
  components: {ApprovalModal, IPhoneModelContainer, AppBox, AppHeader},
  data() {
    return {
      states: null,
    };
  },
  mounted() {
    let lessonId = this.$Base64.decode(this.$route.params.lessonId);
    let version = this.$Base64.decode(this.$route.params.version);
    this.$refs.iPhoneModelContainer.getDataFromFa(lessonId, version);
  },
  methods: {
    ...mapMutations("teachingCenter", ["setData"]),
    handleDisagree() {
      this.states = 3;
      this.setData({key: "approvalModalVisible", value: true});
    },
    handleAgree() {
      this.states = 2;
      this.setData({key: "approvalModalVisible", value: true});
    },
  },
};
</script>

<style lang="scss" scoped>
.ApprovalCourse {
  .appBox {
    min-height: calc(100vh - 170px);
  }
}
</style>
